import React, {useEffect, useRef} from "react";
import { webAnalytics } from "@principal/web-analytics";
import {FormikValues, useFormikContext} from "formik";

export function trackFormEvent(event: any, claimId: string) {
    webAnalytics.trackEvent(event, {
        type: 'person-management',
        name: 'disability-claim-forms',
        id: claimId,
        lead: 'no',
    });
}

const FormViewMetric = () => {
    const { touched, values } = useFormikContext<FormikValues>();
    const hasTrackedFormStart = useRef(false);

    useEffect(() => {
        if (Object.keys(touched).length > 0 && !hasTrackedFormStart.current) {
            trackFormEvent('formStart', values.claimId);
            hasTrackedFormStart.current = true;
        }
    }, [touched, values.claimId]);

    return (<></>)
};
export default FormViewMetric;
